import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export default function SnackbarComponent({message, open, handleClose, color='green'}) {
  return (
    <div>
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={open}
            onClose={handleClose}
            message={message}
            key={message}
            autoHideDuration={3000}
            slots={{ transition: SlideTransition }}
            slotProps={{
                content: {
                    sx: {
                        backgroundColor: color
                    }
                }
            }}
        />
    </div>
  );
}